import { html } from "lit-html";

type RenderIconArgs = {
  iconId: string;
  cssClasses?: string;
};

export const renderIcon = (args: RenderIconArgs) => {
  return html`
    <wec-e-icon class="wec-e-icon ${args.cssClasses ? args.cssClasses : ""}" icon-id="${args.iconId}"></wec-e-icon>
  `;
};
